import React from "react";
import {
  MdAdd,
  MdRemove,
  MdMyLocation,
  MdCropSquare,
  MdDraw,
} from "react-icons/md";

const MapControls = ({
  onZoomIn,
  onZoomOut,
  onResetView,
  onToggleDrawRect,
  onToggleDrawPolygon,
  drawMode = null,
  isDark = false,
}) => {
  const bg = isDark ? "#1f2937" : "#ffffff";
  const borderColor = isDark ? "#374151" : "#e5e7eb";
  const color = isDark ? "#f9fafb" : "#374151";

  const btnStyle = (isActive) => ({
    background: isActive ? "#f59e0b" : bg,
    border: `1px solid ${borderColor}`,
    color: isActive ? "#ffffff" : color,
    cursor: "pointer",
    width: 36,
    height: 36,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    transition: "background 0.15s",
    padding: 0,
  });

  return (
    <div
      style={{
        position: "absolute",
        top: 14,
        right: 14,
        zIndex: 10,
        display: "flex",
        flexDirection: "column",
        gap: 7,
      }}
    >
      <button
        style={btnStyle(false)}
        onClick={onZoomIn}
        title="Zoom In"
        aria-label="Zoom In"
      >
        <MdAdd />
      </button>
      <button
        style={btnStyle(false)}
        onClick={onZoomOut}
        title="Zoom Out"
        aria-label="Zoom Out"
      >
        <MdRemove />
      </button>
      <button
        style={btnStyle(false)}
        onClick={onResetView}
        title="Reset View"
        aria-label="Reset View"
      >
        <MdMyLocation />
      </button>
      <div
        style={{ height: 1, background: borderColor, margin: "2px 0" }}
        role="separator"
      />
      <button
        style={btnStyle(drawMode === "rectangle")}
        onClick={onToggleDrawRect}
        title="Draw Rectangle"
        aria-label="Draw Rectangle"
      >
        <MdCropSquare />
      </button>
      <button
        style={btnStyle(drawMode === "polygon")}
        onClick={onToggleDrawPolygon}
        title="Draw Polygon"
        aria-label="Draw Polygon"
      >
        <MdDraw />
      </button>
    </div>
  );
};

export default MapControls;
